'use strict';
angular
  .module('eclipseApp.core')
  .controller('timerModal', [
    '$scope',
    'timerService',
    '$modal',
    '$modalInstance',
    '$location',
    '$window',
    '$http',
    'notifier',
    '$rootScope',
    'uteEndpoint',
    'cartManager',
    'commonService',
    '$state',
    timerModal
  ]);

function timerModal(
  $scope,
  timerService,
  $modal,
  $modalInstance,
  $location,
  $window,
  $http,
  notifier,
  $rootScope,
  uteEndpoint,
  cartManager,
  commonService,
  $state
) {
  $rootScope.$on('timerModalOpen', function(env, params) {
    cartManager.cleanCart().then(
      function() {
        $window.deleteCookie('userPref', true);
        $window.deleteCookie('atg', true);
        commonService.resetServiceData();
        $http({
          method: 'POST',
          url: uteEndpoint('v1/discardBrowseSession')
        })
          .success(function(res) {
            timerService.stopTimer();
            if (
              $window.sessionStorage.getItem('__adl') != null &&
              $window.sessionStorage.getItem('__adl').includes('internet')
            ) {
              $window.sessionStorage.setItem('sessionExpired', true);
            }

            if (params && params.navigate) {
              timerService.startTimer();
              notifier.notify.done();
              $location.url('/internet');
            }
          })
          .error(function(res, status) {
            $modalInstance.close();
            switch (status) {
              case 500:
              case 5000:
              case 50000:
                notifier.notify.error({
                  errorCode: status
                });
                break;
              default:
                notifier.notify.error();
            }
          });
      },
      function(error) {
        notifier.notify.error();
      }
    );
  });
  //StartOver function
  $scope.startOver = function() {
    $modalInstance.dismiss();

    /**
     *  As part of CH-4670 story, if the session gets timed out in internet page we are reloading
     * the internet page, if its some other NAC page, we are redirecting it to internet
     * */

    var stateName = $state.current.name;
    if (stateName === 'internet') {
      $state.go($state.current, {}, { reload: true });
    } else {
      $state.go('internet');
    }
    $window.sessionStorage.removeItem('sessionExpired');
    timerService.resetTimer();
  };

  $scope.sessionContinue = function() {
    var params = {
      userId: $rootScope.atg && $rootScope.atg.userId ? $rootScope.atg.userId.value : 'default',
      hashKey: $rootScope.atg && $rootScope.atg.hashKey ? $rootScope.atg.hashKey.value : 'default'
    };
    $http({
      method: 'POST',
      url: uteEndpoint('checkHeartBeat'),
      data: params
    })
      .success(function(res) {
        $modalInstance.close();
        timerService.stopTimer();
        timerService.startTimer();
      })
      .error(function(res, status) {
        $modalInstance.close();
        switch (status) {
          case 500:
          case 5000:
          case 50000:
            notifier.notify.error({
              errorCode: status
            });
            break;
          default:
            notifier.notify.error();
        }
      });
  };
  $scope.existClose = function() {
    $rootScope.$broadcast('timerModalOpen', { navigate: true });
    $modalInstance.close();
  };
}
